// tslint:disable:no-trailing-whitespace
// tslint:disable:member-ordering
import { BaseEntity } from '../base-entity';
import { Contribution } from './contribution';
import { ContributionAccount } from './contribution-account';

/// <code-import> Place custom imports between <code-import> tags

/// </code-import>

/// <module-code> Place module level code between <module-code> tags

/// </module-code>

export class ContributionLine extends BaseEntity  {

  /// <code> Place custom code between <code> tags
  allowSelect: boolean;
  /// </code>

  // Generated code. Do not place code below this line.
  id!: number;
  accountId?: number;
  amount!: number;
  contributionId!: number;
  created?: Date;
  createdBy?: string;
  modified?: Date;
  modifiedBy?: string;
  note?: string;
  otherAccount?: string;
  rowVersion?: number;
  account!: ContributionAccount;
  contribution!: Contribution;
}

